import type { Component, Ref } from 'vue';
import type { FieldTypeFilterConfig } from '#layers/data-model';
import type { SegmentedFieldFilter } from './utils/filter-path';
import type { FilterSchemaPrimitiveField } from './utils/filter-schema';
import { createContext } from 'reka-ui';

/** Public context for custom filter input components */
export interface FilterInputContext {
	/** Resolved leaf input (template's filter.input or default FilterInputComponent) */
	FilterInput: Component;
	/** Default FilterInputGroup for conditional delegation — just render <component :is="FilterInputGroup" />, no props needed */
	FilterInputGroup: Component;
}

export const [injectFilterInputContext, provideFilterInputContext] =
	createContext<FilterInputContext>('FilterInput');

/** Private context for FilterInputGroup delegation — not for external use */
export interface FilterInputGroupDelegateContext {
	primitiveField: Ref<FilterSchemaPrimitiveField>;
	filterConfig: Ref<FieldTypeFilterConfig | undefined>;
	typeOptions: Ref<Record<string, unknown>>;
	model: Ref<SegmentedFieldFilter | null>;
	disabled: Ref<boolean>;
}

export const [injectFilterInputGroupDelegateContext, provideFilterInputGroupDelegateContext] =
	createContext<FilterInputGroupDelegateContext>('FilterInputGroupDelegate');
